
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import DecimalControl from "@/components/controls/base/DecimalControl.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import EnumControl from "@/components/controls/base/EnumControl.vue";
import TextControl from "@/components/controls/base/TextControl.vue";
import { DxCheckBox } from "devextreme-vue/check-box";

export default defineComponent({
  components: {
    CreateEditDialog,
    EnumControl,
    IntegerControl,
    DecimalControl,
    TextControl,
    DxCheckBox,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  data() {
    return {
      nomenclatureVolumeConstraintItemSubGridDomId:
        "PlanOrderNomenclatureVolumeConstraintCreateEditDialog_nomenclatureVolumeConstraintItemSubGridDomId",
    };
  },
  beforeUnmount() {
    (this as any).unmountComponent(
      (this as any).nomenclatureVolumeConstraintItemSubGridDomId
    );
  },
  computed: {
    volume: function () {
      const model = this.dialog().createEditModel;
      // Использование глобальной переменной
      if (model.percent && window.globalThis.volume)
        return (model.percent * window.globalThis.volume) / 100;
      else return null;
    },
  },
  methods: {
    onShown(model: any) {
      (this as any).mountComponent(
        "components/journals/PlanOrderJournal/PlanOrderNomenclatureVolumeConstraintItemSubCatalogueGrid.vue",
        (this as any).nomenclatureVolumeConstraintItemSubGridDomId,
        {
          parentModel: model,
        }
      );
    },
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
  },
});
